import { clearResetForm, resetForm } from '../slices/form.slice';
import { AppListenerEntry } from '@/redux';

const CLEAR_DELAY = 300;

export const epicResetForm: AppListenerEntry = {
  actionCreator: resetForm,
  effect: async (_action: ReturnType<typeof resetForm>, { getState, delay, dispatch }) => {
    if (getState().form.isReset) {
      await delay(CLEAR_DELAY);
      dispatch(clearResetForm());
    }
  }
};
